import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { FormBuilder, FormGroup, Validators, FormGroupDirective, FormControl } from '@angular/forms';
import { ValidatorsService } from 'src/app/services/validators/validators.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { startWith, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ClientaccountService } from 'src/app/services/apiclient/clientaccount/clientaccount.service';
import { CountriesService } from 'src/app/services/apiclient/countries/countries.service';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { ClientaddressesService } from 'src/app/services/apiclient/clientaddresses/clientaddresses.service';
import { AddressComponent } from '../../dialogs/client-address/address/address.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MediaObserver } from '@angular/flex-layout';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import * as moment from 'moment';
import { ClientPhoneComponent } from '../../dialogs/client-phone/client-phone.component';
import { ClientPasswordComponent } from '../../dialogs/client-password/client-password.component';
import { DeleteClientAccountComponent } from '../../dialogs/delete-client-account/delete-client-account.component';
import { TranslateService } from '@ngx-translate/core';


export const MY_FORMATS = {


  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};
@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },

  ]
})

export class AccountComponent implements OnInit {

  @ViewChild('autoCompleteCountry', { read: MatAutocompleteTrigger }) acCountry: MatAutocompleteTrigger | any;

  @Input()
  user$: any;

  @Input()
  clientAccount$: any;

  @Input()
  countries$: any;

  error$: string | any;
  currEmail: string | any;

  // Loaders
  loaders: any = {
    page: true,
    forms: false,
    countries: false
  };

  // Forms
  emailForm: FormGroup | any;
  passwordForm: FormGroup | any;
  firstNameForm: FormGroup | any;
  lastNameForm: FormGroup | any;
  phoneForm: FormGroup | any;
  birthForm: FormGroup | any;

  accountForm: FormGroup | any;
  minDate: moment.Moment = moment(new Date("01/01/1900"));

  maxDate: moment.Moment = moment(new Date("01/01/2100"));

  statusMessage: any = this.translate.instant('accountComp.messageLoaderGetInfos');

  //Filtered data
  filteredCountries: Observable<any> | any;
  panelOpenState: boolean = false;
  clientAddresses$: any;
  currAddress$: any;
  constructor(
    private formBuilder: FormBuilder,
    private vs: ValidatorsService,
    private auth: AuthService,
    private clientApi: ClientaccountService,
    private countriesApi: CountriesService,
    private tools: ToolsService,
    private addressApi: ClientaddressesService,
    private dialog: MatDialog,
    private media: MediaObserver,
    public translate: TranslateService
  ) { }

  ngOnInit() {

    this.tools.setPageClient("account");

    this.adress();

    this.auth.getUser.subscribe(user => {
      this.user$ = user;
    });


    this.clientApi.getCurrClientAccount().subscribe(client => {

      if (client) {

        this.clientAccount$ = client;
     

        this.countriesApi.getCountries().subscribe(countries => {

          this.countries$ = countries;

          this.createAllForm();
          this.loaders.page = false;

        })

      }

    });

    this.auth.getError.subscribe((data) => {
      this.error$ = data;
      if(this.error$){
        setTimeout(() => {
          this.cleanError();
        }, 8000);
      }
    

    });

  }

  adress() {

    this.addressApi.getAddresses.subscribe(addresses => {
      if (addresses) {
        this.clientAddresses$ = addresses;
      }
    });

    this.addressApi.getClientAddresses().subscribe(addresses => {
      this.clientAddresses$ = addresses;
    });

    this.addressApi.getBillingAddress.subscribe((address) => {
      this.currAddress$ = address;
    });
  }



  // CREATE FORMS

  createAllForm(): void {
    // this.creatPasswordForm();
    //  this.creatEmailForm();
    // this.createFirstnameForm();
    // this.createLastnameForm();
    // this.createPhoneForm();
    // this.createBirthForm();
    this.createAccountForm();
  }





  // creatPasswordForm(): void {
  //   this.passwordForm = this.formBuilder.group({
  //     password: ['', [Validators.required, Validators.minLength(6)]],
  //     confPassword: ['', [Validators.required]]
  //   }, {
  //     validator: this.vs.MatchPassword
  //   });
  // }

  // creatEmailForm(): void {
  //   this.emailForm = this.formBuilder.group({
  //     email: [this.clientAccount$.mail, [Validators.required, Validators.email]]
  //   });
  // }

  // createFirstnameForm(): void {
  //   this.firstNameForm = this.formBuilder.group({
  //     firstName: [this.clientAccount$.firstname, [Validators.required, Validators.pattern("^[^0-9]+$")]]
  //   });
  // }

  // createLastnameForm(): void {
  //   this.lastNameForm = this.formBuilder.group({
  //     lastName: [this.clientAccount$.lastname, [Validators.required, Validators.pattern("^[^0-9]+$")]]
  //   });
  // }

  // createPhoneForm(): void {
  //   this.phoneForm = this.formBuilder.group({
  //     phone: ['', [Validators.required, Validators.pattern("[^a-zA-Z]{1,}")]],
  //     country_name: ['', [Validators.required]],
  //     id_country: '',
  //   });
  //   this.getCountriesOnChange();
  // }

  // createBirthForm(): void {
  //   this.birthForm = this.formBuilder.group({
  //     birth: [this.clientAccount$.birth, [Validators.required]]
  //   });
  // }

  createAccountForm(): void {
    this.accountForm = new FormGroup({
      firstName: new FormControl(this.clientAccount$.firstname, [Validators.required, Validators.pattern("^[^0-9]+$")]),
      lastName: new FormControl(this.clientAccount$.lastname, [Validators.required, Validators.pattern("^[^0-9]+$")]),
      email: new FormControl(this.clientAccount$.mail, [Validators.required, Validators.email]),
      birth: new FormControl(this.clientAccount$.birth),
      //birth: new FormControl(this.clientAccount$.birth, [Validators.required]),
      society: new FormControl(this.clientAccount$.society),
      enable_marketing: new FormControl(this.clientAccount$.enable_marketing),
    });
  }


  // CLOSE OPTIONS

  // onClosAccor(formDirective: FormGroupDirective): void {
  // formDirective.resetForm();
  // this.emailForm.reset();
  // this.passwordForm.reset();
  // this.firstNameForm.reset();
  // this.lastNameForm.reset();
  // this.phoneForm.reset();
  // this.birthForm.reset();

  // }



  onSubmit(): void {
    const that = this;

    if (that.accountForm.valid) {
      this.accountForm.value.enable_marketing
      this.currEmail = this.accountForm.value.email;
      let toSend = {

        birth: this.accountForm.value.birth ? moment(this.accountForm.value.birth).format('YYYY-MM-DD') : null,
        mail: this.accountForm.value.email,
        enable_marketing: this.accountForm.value.enable_marketing ? 1 : 0,
        firstname: this.accountForm.value.firstName,
        lastname: this.accountForm.value.lastName,
        society:this.accountForm.value.society
      }


      that.beforeCallApi(this.translate.instant('accountComp.messageLoaderChangeInfos'));



      that.auth.updateclient(toSend, "successAll").then((data) => {

        that.afterCallApiAll(data);

      });

    }
  }



  // SUBMIT FORMS

  // submitNewEmail(formDirective: FormGroupDirective, panel: any): void {
  //   const that = this;


  //   that.currEmail = that.emailForm.value.email;

  //   if (that.emailForm.valid) {

  //     that.beforeCallApi("Modification de votre email");

  //     that.auth.updateEmail(that.emailForm.value.email).then((data) => {

  //       that.afterCallApi(panel, formDirective, data);

  //     });

  //   }
  // }

  // submitNewPassword(formDirective: FormGroupDirective, panel: any): void {
  //   const that = this;
  //   const formVal = that.passwordForm.value;

  //   if (that.passwordForm.valid) {

  //     that.beforeCallApi("Modification de votre mot de passe");

  //     that.auth.updatePassword(formVal.password).then(data => {
  //       that.afterCallApi(panel, formDirective, data);

  //     })
  //   }
  // }

  // submitNewFirstName(formDirective: FormGroupDirective, panel: any): void {
  //   const that = this;
  //   const params = {
  //     firstname: that.firstNameForm.value.firstName
  //   }
  //   if (that.firstNameForm.valid) {

  //     that.beforeCallApi("Modification de votre prénom");

  //     that.auth.updateClient(params, "successfirstname").then(data => {

  //       that.afterCallApi(panel, formDirective, data);

  //     });

  //   }
  // }

  // submitNewLastName(formDirective: FormGroupDirective, panel: any): void {
  //   const that = this;
  //   const params = {
  //     lastname: that.lastNameForm.value.lastName
  //   }

  //   if (that.lastNameForm.valid) {

  //     that.beforeCallApi("Modification de votre nom");

  //     that.auth.updateClient(params, "successlastname").then(data => {

  //       that.afterCallApi(panel, formDirective, data);

  //     });

  //   }
  // }

  // submitNewPhone(formDirective: FormGroupDirective, panel: any): void {
  //   const that = this;
  //   const params = {
  //     phone: that.phoneForm.value.phone,
  //     id_country: that.phoneForm.value.id_country
  //   };

  //   if (that.phoneForm.valid) {

  //     that.beforeCallApi("Modification de votre téléphone");

  //     that.auth.updateClient(params, "successphone").then(data => {

  //       that.afterCallApi(panel, formDirective, data);

  //     });
  //   }
  // }

  // submitNewBirth(formDirective: FormGroupDirective, panel: any): void {
  //   const that = this;
  //   const params = {
  //     birth: that.birthForm.value.birth,
  //   };

  //   if (that.birthForm.valid) {

  //     that.beforeCallApi("Modification de votre date de naissance");

  //     that.auth.updateClient(params, "successbirth").then(data => {

  //       that.afterCallApi(panel, formDirective, data);

  //     });

  //   }
  // }

  reLog() {

    this.auth.logOut("/auth/home%22account");

  }

  // Automate stains

  beforeCallApi(message: string) {
    this.statusMessage = message;
    this.error$ = "";
    this.loaders.forms = true;
  }

  afterCallApiAll(data: any) {
    if (data) {
      this.clientApi.setCurrClientAccount(data);
    }
    this.loaders.forms = false;
  }

  afterCallApi(panel: any, formDirective: FormGroupDirective, data: any) {
    if (data) {
      this.clientApi.setCurrClientAccount(data);
    }

    // panel.close();
    // this.onClosAccor(formDirective);
    this.loaders.forms = false;
  }

  // Autocomplete countries

  // onSelectCountry(country: any): void {
  //   this.phoneForm.get("id_country").setValue(country.id);
  //   this.phoneForm.get("phone").reset();
  // }

  // getCountriesOnChange(): void {
  //   this.phoneForm.get("country_name").valueChanges
  //     .pipe(
  //       startWith(''),
  //       tap(() => {
  //         this.loaders.countries = true;
  //       }),
  //     )
  //     .subscribe(value => {

  //       if (value) {

  //         const filteredValueResults = this.filterCountries(value);
  //         this.filteredCountries = (filteredValueResults.length > 0) ? filteredValueResults : null;

  //       } else {

  //         this.filteredCountries = this.countries$.slice();

  //       }

  //       this.loaders.countries = false;

  //     });
  // }

  // filterCountries(value: string): any {
  //   const filterValue = value.toLowerCase();
  //   return this.countries$.filter((country: any) => country.name.toLowerCase().indexOf(filterValue) === 0);
  // }



  /**
    * @description Ouvre la dialog de création d'adresse
    * @param {any} address
    * @returns {void}
    */
  openDialAddress(): void {


    // this.panelOpenState = false;

    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      address: this.currAddress$,
      clientAddresses: this.clientAddresses$,
      type: 'billing',
      cometoaccount: true
    };

    this.media.isActive("xs")
      ? (myConf.width = "100%", myConf.height = "100%")
      : (myConf.width = "550px", myConf.minHeight = "500px");

    const myDial = this.dialog.open(AddressComponent, myConf);

    myDial.afterClosed().subscribe((data) => {
      if (data) {
        this.addressApi.setBillingAddress(data.address);
      }

    });
  }



  /**
   * @description Ouvre la dialog de modification phone
   * @param {any} phone
   * @returns {void}
   */
  openDialPhone(): void {


    const myConf = new MatDialogConfig();


    myConf.data = {
      clientAccount: this.clientAccount$,
      countries: this.countries$,

    };

    this.media.isActive("xs")
      ? (myConf.width = "100%", myConf.height = "100%")
      : (myConf.width = "550px", myConf.minHeight = "500px");

    const myDial = this.dialog.open(ClientPhoneComponent, myConf);

    myDial.afterClosed().subscribe((data) => {


      if (data) {
        setTimeout(() => {
          this.cleanError();
        }, 2000);
        return;
      }
      this.cleanError();

    });
  }



  /**
  * @description Ouvre la dialog de modification password
  * @param {any} password
  * @returns {void}
  */
  openDialPassword(): void {


    const myConf = new MatDialogConfig();

    myConf.data = {
      clientAccount: this.clientAccount$,
    };

    this.media.isActive("xs")
      ? (myConf.width = "100%", myConf.height = "100%")
      : (myConf.width = "550px", myConf.minHeight = "500px");

    const myDial = this.dialog.open(ClientPasswordComponent, myConf);

    myDial.afterClosed().subscribe((data) => {

      setTimeout(() => {
        this.cleanError();
      }, 2000);

    });
  }
  cleanError() {
    if (this.error$ == "errneedlog" || this.error$ == "errHappen") {
      return;
    }
    this.auth.setError(null);
    this.error$ = "";
    this.statusMessage = null;

  }


  delete_account() {
    const myConf = new MatDialogConfig();

    myConf.data = {
      clientAccount: this.clientAccount$,
    };

    this.media.isActive("xs") ? myConf.width = "95%" : myConf.width = "500px";

    const myDial = this.dialog.open(DeleteClientAccountComponent, myConf);


    myDial.afterClosed().subscribe((data) => {

      this.statusMessage= this.translate.instant('deleteClientAccountComponents.loader_delete');
      this.loaders.page = true;
      // delete
      if (data) {
        this.auth.deleteClient(this.clientAccount$).then((data) => {

          if (data && data == "delete") {
            this.loaders.page = false;
            this.clientAccount$ = null;
            this.auth.logOut("auth/home");
            this.loaders.page = false;
          }

        }).catch(err => {
          this.loaders.page = false;

        })
      }
      else {
        this.loaders.page = false;
      }



    });
  }




}
